export enum MenuIdentifersEnum {
    Apps,
    Events,
    SettingsAdmins,
    SettingsConfig,
}
